<template>
  <el-dialog title="" :visible.sync="dialogShow" width="412px" class="myDialog" :modal-append-to-body="false">
    <div>
      <div class="dialog_title">
        <h1>{{dialogTitle}}</h1>
        <h3>——企业赋能 不止卓越——</h3>
      </div>
      <div class="dialog_part01" v-show="partNum == 1">
        <div>
          <input class="formStyle" type="text" placeholder="企业名称" name="agencyName" v-model="form.agencyName">
          <input class="formStyle" type="text" placeholder="姓名" name="agencyName" v-model="form.applyContactName">
          <div class="mobileOuter">
            <input class="formStyle mobileNum" type="text" placeholder="您的手机号码" name="mobile" v-model="form.mobile">
            <button class="codeGet" @click="codeGet">获取验证码</button>
          </div>
          <input class="formStyle" type="text" placeholder="您的验证码" name="verifyCode" v-model="verifyCode">
        </div>
        <button class="loginNow" @click="loginNow">立即体验</button>
      </div>
      <div class="dialog_part02" v-show="partNum == 2">
        <p>稍后会有客服联系提供账号信息密码<br>请注意接听</p>
        <button class="loginNow loginConfirm" @click="dialogShow = false">确定</button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import $ from 'jquery'
  import allService from '@/js/allservice.js'
    export default {
        name: "my-dialog",
        data:function(){
          return {
            dialogTitle:'免费体验',
            partNum:1,
            form:{
              agencyName:'',
              mobile:'',
              applyContactName:'',
            },
            verifyCode:'',
            serverUrl:''
          }
        },
        props: {
          showDialog: {   // 是否显示用户选择模态框，该值双向绑定
            required: true,
            type: Boolean,
            default: false
          }
        },
        computed: {
          dialogShow: {
            get: function() {
              return this.showDialog;
            },
            set: function (value) {
              this.$emit("update:showDialog", value);
            }
          }
        },
        mounted:function(){
          var vm = this;
          vm.partNum = 1;
          vm.serverUrl = process.env.SERVER_API;
          console.log(vm.serverUrl);
        },
        methods:{
          codeGet:function(e){//获取验证码
            var vm = this;
            var el = e.target;
            if(!($(el).html() == '获取验证码' || $(el).html() =='重新发送')){//校验验证码重复发送的问题
              return;
            }
            //校验手机号码时候正确
            if(!vm.verifyMobileFormat(vm.form.mobile)){
              this.$message.error('手机号码格式错误，请重新输入!');
              vm.form.mobile = '';
              return;
            }
            if($(el).html() == '获取验证码' || $(el).html() =='重新发送'){
              var code = 60;
              $(el).html(code);
              var timer = setInterval(function(){
                code--;
                if(code < 0){
                  $(el).html('重新发送');
                  clearInterval(timer);
                }else{
                  $(el).html(code);
                }
              },1000);
            }
            allService.sendVerifyCode(vm,vm.form.mobile).then(function(data){
              console.log(data);
              vm.$message.success(data);
            });
            /*$.ajax({
              type:"GET",
              url:vm.serverUrl+"applyContact/sendVerifyCode?mobile="+vm.form.mobile,
              dataType:"string",
              success:function(data){
                console.log(data);
              },
              error:function(jqXHR){
                console.log(jqXHR);
                var responseText = jqXHR.responseText;
                //将json 字符串转为json对象
                responseText = $.parseJSON(responseText);
                console.log(responseText);
                if(responseText.success){
                  vm.$message.success(responseText.dataList[0]);
                }
                if(responseText.error){
                  vm.$message.error(responseText.error);
                }
              }
          });*/
          },
          verifyMobileFormat:function(value){
            if (value == null || value == 'null' || value == '' || typeof(value) == 'undefined') {
              this.$message.error('请您填写手机号码!');
              return false;
            }
            // 大陆
            // ^((\\+86\\-)?)1(3|5|7|8)\\d{9}$
            var mobileMainland = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/;
            // 香港
            // ^(\\+852\\-)(5|6|9)\\d{7}$
            var mobileHongKong = /^((\+852\-)(2|5|6|9)+\d{7})$/;
            // 澳门
            // ^(\\+853\\-)(6|8)\\d{7})$
            var mobileAomen = /^((\+853\-)(6|8)+\d{7})$/;
            // 台湾
            // ^(\\+886\\-)09\\d{8}$
            var mobileTaiwan = /^((\+886\-)(09)+\d{8})$/;
            return mobileMainland.test(value) || mobileHongKong.test(value) || mobileAomen.test(value) || mobileTaiwan.test(value)
          },
          loginNow:function(){//立刻体验
            var vm = this;
            if(!vm.form.agencyName){
              this.$message.error('请您填写公司名称！');
              return;
            }
            if(!vm.form.applyContactName){
              this.$message.error('请您填写姓名！');
              return;
            }
            if(!vm.form.mobile){
              this.$message.error('请您填写手机号码!');
              return;
            }
            if(!vm.verifyCode){
              this.$message.error('请您填写验证码!');
              return;
            }
            //校验手机号码
            if(!vm.verifyMobileFormat(vm.form.mobile)){
              this.$message.error("手机号码格式错误，请重新输入!");
              return;
            }
            allService.save(vm,vm.verifyCode,vm.form).then(function(data){
              console.log(data);
              if(data) {
                vm.partNum = 2;
              }
            }).catch(function(error){
              console.log(error);
              vm.$message.error("验证码不正确，请重新填写！");
            });
           /* $.ajax({
              type:"POST",
              url:vm.serverUrl+"applyContact/save?verifyCode="+vm.verifyCode,
              data:JSON.stringify(vm.form),
              dataType:"json",
              contentType: 'application/json; charset=UTF-8',
              success:function(data){
                if(data.success){
                  vm.partNum = 2;
                }else{
                  vm.$message.error("验证码不正确，请重新填写！");
                  vm.verifyCode = '';
                  return;
                }
              },
              error:function(jqXHR){
                alert("发生错误："+ jqXHR.status);
              }
            });*/

          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/my-dialog.vue